<template>
  <section class="max-w-2xl mx-auto my-16">
    <div class="flex flex-col items-center justify-center">
      <h2 class="text-3xl text-(--main-color) mt-28">
        Veuillez saisir votre code de validation
      </h2>
      <UPinInput
        v-model="code"
        autofocus
        class="mt-16"
        color="main"
        highlight
        length="6"
        placeholder="0"
        size="xl"
        variant="ghost"
        @complete="onComplete"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { validateUser } from "~/models/user";
import type { ApiError } from "~/models/error";

const { successToast, errorToast } = useToastMessages();
const { $api } = useNuxtApp();
const router = useRouter();

const code = ref();

const onComplete = async () => {
  try {
    const response: validateUser | ApiError = await $api.post(
      "/user/confirm-email",
      { code: code.value.join("") },
      "include"
    );
    if ("status" in response) {
      errorToast("Erreur de validation", "Le code de validation est incorrect");
    } else {
      successToast(
        "Validation du code reussi",
        "Votre compte est desormais activer"
      );
      await router.push("/");
    }
  } catch (e) {
    console.log(e);
    errorToast(
      "Erreur de validation",
      "Erreur serveur, veuillez contacter l'administrateur du site"
    );
  }
};
</script>
